import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const pancakeswapApi = createApi({
  reducerPath: 'getPancakeswap',
  baseQuery: fetchBaseQuery({ baseUrl: 'https://' }),
  endpoints: builder => ({
    getPancakeswap: builder.query<object, void>({
      query: () => 'api.pancakeswap.info/api/v2/pairs',
      transformResponse: (response: any) => {
        return response.data
      }
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetPancakeswapQuery } = pancakeswapApi
